import { getAccessToken, isRedirectStarted } from 'app/infrastructure/auth';

const getToken = async () => await getAccessToken();

export const authProvider = {
  headers: async () => {
    const token = await getToken();
    if (token) {
      return {
        authorization: `Bearer ${token}`
      };
    }
    return {};
  },
  processResponse: async (response: Response) => response,
  // Noop with standard authentication. Used by anonymous client for case password.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setAuthorization: (auth: string) => undefined,
  getAuthorization: (): string => undefined,
  get redirectStarted() { return isRedirectStarted() },
  get isAnonymous() { return false }
};
